import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Carousel } from 'react-bootstrap';

const ViewComm = (props) => {
    const [show, setShow] = useState(false);
    const [userName, setUserName] = useState('');
    const [content, setContent] = useState('');
    const [thumbnail, setThumbnail] = useState(null);
    const [thumbnailName, setThumbnailName] = useState('');
    const [uploading, setUploading] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [today, setToday] = useState('');
    const [commId, setCommId] = useState('');
    const [likeCount, setLikeCount] = useState(0);
    const [commentCount, setCommentCount] = useState(0);
    const [comments, setComments] = useState([]);
    const [liked, setLiked] = useState(false);
    const [showComments, setShowComments] = useState(false);
    const [images, setImages] = useState([]);
    useEffect(() => {
        if (props.data) {
            setUserName(props.data.username || '');
            setContent(props.data.caption || '');
            setThumbnail(props.data.image || '');
            setThumbnailName(props.data.thumbnailName || '');
            setCommId(props.data.comm_id || '');
            setImages(props.data.image ? props.data.image.split(',') : []);

            if (props.data.image) {
                const fileName = props.data.image.substring(props.data.image.lastIndexOf('/') + 1);
                setThumbnailName(fileName);
            }

            const currentDate = new Date(props.data.dateofpost);
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            setToday(formattedDate);

            const likeNumbers = props.data.likecount ? props.data.likecount.split(',').length : 0;
            setLikeCount(likeNumbers);

            const commentNumbers = props.data.commentcount ? props.data.commentcount.split(',').length : 0;
            setCommentCount(commentNumbers);

            setComments(props.data.comments ? props.data.comments.split(',') : []);
        }
    }, [props.data]);

    const handleClose = () => setShow(false);
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true);
    };

    const handleLikeButtonClick = () => {
        setLiked(!liked);
        setLikeCount(likeCount + (liked ? -1 : 1));
    };

    const handleCommentsButtonClick = () => {
        setShowComments(!showComments);
    };

    return (
        <>
            <Button onClick={handleShow} className="btn-square btn btn-success mx-2"><i className='fa fa-eye'></i></Button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>View Community Post</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="needs-validation" noValidate>
                        <Row className="g-3">
                            <Col md={6}>
                                <Col md={12}>
                                    <Form.Group controlId="validationCustom01">
                                        <Form.Label>Username</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={userName}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={12}>
                                    <Form.Group controlId="exampleFormControlTextarea1">
                                        <Form.Label>Caption</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={6}
                                            value={content}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>

                                {showComments && (
                                    <Col md={12}>
                                        <Form.Group controlId="exampleFormControlComments">
                                            <Form.Label>Comments</Form.Label>
                                            <div style={{ maxHeight: '100px', overflowY: 'scroll' }}>
                                                {comments.map((comment, index) => (
                                                    <div key={index} className="comment">
                                                        {comment}
                                                    </div>
                                                ))}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                )}


                            </Col>
                            <Col md={6}>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Images</Form.Label>
                                        <Carousel
                                            className='d-flex'
                                            indicators={images.length > 1}
                                            controls={images.length > 1}
                                        >
                                            {props.data.image.split(',').map((img, idx) => (
                                                <Carousel.Item key={idx}>
                                                    <img
                                                        className="d-block w-100 "
                                                        style={{ height: "250px" }}
                                                        src={img}
                                                        alt={`Slide ${idx + 1}`}
                                                    />
                                                </Carousel.Item>
                                            ))}
                                        </Carousel>
                                    </Form.Group>
                                </Col>
                                <Row className='pt-2'>
                                    <Col md={6}>
                                        <Form.Group controlId="exampleFormControlLikes">
                                            <span className="ms-2">Likes: {likeCount}</span>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="exampleFormControlComments">
                                            <span className="ms-2">Comments: {commentCount}</span>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewComm;
